<script lang="ts">
	export let customClass = '';
</script>

<div class="grid animate-pulse grid-cols-1 gap-y-6 md:grid-cols-3 {customClass}">
	{#each { length: 4 } as _}
		<div class="h-7 rounded-full bg-gray-200 md:col-start-2"></div>
	{/each}
</div>
